import BulkAssignProjectRolesModal, {
  ProjectIdWithPermissions,
} from 'modules/project_management/components/modals/BulkAssignProjectRolesModal'

interface AssignRolesModalProps {
  ids: string[]
  onCloseModal?: () => void
  projectIdWithPermissions?: ProjectIdWithPermissions[]
}

export const AssignRolesModal = ({
  ids,
  onCloseModal,
  projectIdWithPermissions,
}: AssignRolesModalProps) => {
  const finalProjectIdWithPermissions =
    projectIdWithPermissions ?? ids.map((id) => ({ id, canAssignOwners: false }))

  return (
    <BulkAssignProjectRolesModal
      projectIdWithPermissions={finalProjectIdWithPermissions}
      projectIds={ids}
      onClose={() => onCloseModal?.()}
    />
  )
}
